import { render, staticRenderFns } from "./FinderTabs.vue?vue&type=template&id=4be17369&"
import script from "./FinderTabs.vue?vue&type=script&lang=js&"
export * from "./FinderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports